import React, { useState, useEffect } from 'react';
import styles from './topbar.module.css';
import statisticsApi from '../../../lib/statisticsApi';
import Item from './item/item';
import SearchBox from '../../../lib/component/searchBox/searchBox';
import handle from '../../handle';
import NativeShare from 'nativeshare';

export default ({ showLeftIcon, topbarTitle, rightIcon }: { showLeftIcon: boolean; topbarTitle: string; rightIcon: string }) => {
  const { hreList, showHrefList, setShowHrefList, showSearchBox, setShowSearchBox } = handle();

  const [showShare, setShowShare] = useState<boolean>(false);
  const [showTip, setShowTip] = useState<boolean>(false);
  const [id, setId] = useState('');

  function shareTo() {
    // https://github.com/fa-ge/NativeShare/blob/master/README.md

    var nativeShare = new NativeShare();
    nativeShare.setShareData({
      link: window.location.href,
      desc: '豆丁书房',
    });
    try {
      nativeShare.call();
    } catch (err) {}
  }

  const imgStr = [
    {
      imgUrl: 'https://st.douding.cn/images_cn/iphone/collect/ico_share_qq.png',
      text: 'QQ好友',
    },
    {
      imgUrl: 'https://st.douding.cn/images_cn/iphone/collect/ico_share_weibo.png',
      text: '新浪微博',
    },
    {
      imgUrl: 'https://st.douding.cn/images_cn/iphone/collect/ico_share_qzone.png',
      text: 'QQ空间',
    },
    {
      imgUrl: 'https://st.douding.cn/images_cn/iphone/collect/ico_share_copylink.png',
      text: '复制链接',
    },
  ];

  useEffect(() => {
    if (showHrefList) {
      setShowSearchBox(false);
    }
  }, [showHrefList]);

  useEffect(() => {
    if (showSearchBox) {
      setShowHrefList(false);
    }
  }, [showSearchBox]);

  useEffect(() => {
    if (showShare) {
      setId(styles.active);
    } else {
      setId('');
    }
  }, [showShare]);

  function copy() {
    window.navigator.clipboard.writeText(window.location.href);
    setShowTip(old => {
      return !old;
    });
    setTimeout(() => {
      setShowTip(false);
    }, 3000);
  }

  return (
    <>
      <div className={styles.topbar}>
        {showLeftIcon ? (
          <div
            className={styles.topbarIcon}
            onClick={() => {
              window.history.back();
            }}
          ></div>
        ) : (
          <div></div>
        )}
        <div className={styles.topbarTitle}>{topbarTitle}</div>
        <div className={styles.topbarRight}>
          {rightIcon === 'search' && (
            <div
              className={styles.topbarRightIcon}
              onClick={() => {
                setShowSearchBox(old => {
                  return !old;
                });
                if (topbarTitle === '书城') {
                  statisticsApi.statisticsApi(160);
                }
              }}
            ></div>
          )}
          {rightIcon === 'share' && (
            <div
              className={styles.topbarRightIcon1}
              onClick={() => {
                setShowShare(old => {
                  return !old;
                });
              }}
            ></div>
          )}
          <div
            className={showHrefList ? styles.topbarRightPoint1 : styles.topbarRightPoint}
            onClick={() => {
              setShowHrefList(old => {
                return !old;
              });
            }}
          ></div>
        </div>
      </div>
      <div className={styles.list} style={{ height: `${showHrefList ? `${Math.ceil(hreList.length / 5) * 30}px` : 0}` }}>
        {hreList.map((item, index) => {
          return <Item key={index} {...{ data: item }}></Item>;
        })}
      </div>
      {showSearchBox && (
        <div className={styles.searchBoxWrap}>
          <SearchBox {...{ kd: '' }}></SearchBox>
        </div>
      )}
      {showShare && (
        <div className={styles.share}>
          <div className={styles.shareBody} id={id}>
            <div
              className={styles.close}
              onClick={() => {
                setShowShare(old => {
                  return !old;
                });
              }}
            ></div>
            <div className={styles.header}>
              <h4>分享</h4>
            </div>
            <div className={styles.content}>
              <div className={styles.shareBox}>
                {imgStr.map((item, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        copy();
                        // shareTo();
                      }}
                    >
                      <span className={styles.icon} style={{ backgroundImage: `url(${item.imgUrl})` }}></span>
                      <span className={styles.text}>{item.text}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.foot}>
              <div className={styles.left}>
                <div className={styles.wx}></div>
                <div className={styles.pyq}></div>
              </div>
              <div>
                请
                <a
                  href="javascript:void(0);"
                  className={styles.footA}
                  onClick={() => {
                    copy();
                  }}
                >
                  复制链接
                </a>
                去粘贴，或轻触浏览器自带
                <span className={styles.rightIcon}></span>
                图标即可分享到微信或朋友圈。
              </div>
            </div>
          </div>
          <div className={styles.mask}></div>
          {showTip && <div className={styles.tip}>复制成功，快去分享给好友吧</div>}
        </div>
      )}
    </>
  );
};
